import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import BenifitStatusViewModel from '../ViewModels/BenifitStatusViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IBenifitStatusDropDownProps {
    setBenifitStatus?: (event) => void;
    benifitStatus: number | undefined;
    disabled: boolean;
}

interface IBenifitStatusDropDownState {
    model: BenifitStatusViewModel[];
    loaded: boolean;
}

class BenifitStatusDropDown extends Component<IBenifitStatusDropDownProps & WithStyles<typeof styles>, IBenifitStatusDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetBenifits').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
            items.push(<MenuItem key="defaultBenifitStatusVal" value='0'>I am not claiming any benefits</MenuItem>);
        }

        return (
            <SelectValidator
                label="Were you also in recipt of one of the following benefits?"
                name="benifitsStatus"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.benifitStatus}
                onChange={this.props.disabled ? undefined : this.props.setBenifitStatus}
                disabled={this.props.disabled}
                validators={['required']}
                errorMessages={['This field is required']}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(BenifitStatusDropDown);